// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"5bca4b88","453":"41882f43"}[chunkId] + ".chunk.js";
};